import _Col from "hzero-ui/lib/col";
import React, { useContext } from 'react';
import ThemeContext from '@hzero-front-ui/core/lib/utils/ThemeContext';
import { hideConfig } from '../../../utils/constants';
import { CheckedIcon, ConfigContainer, ContentWrapper, ItemTitle,
// ItemTitle,
ItemWrapper, Title } from './index.style'; //

var NumberMap = ['样式一', '样式二', '样式三', '样式四'];
/**
 * 配置项组件
 * @param {string | ReactNode} title
 * @param {Array} items
 * @param {number} defaultSelected
 * @param {function} onChange
 * @param simple
 * @param style
 * @param className
 * @param selectable
 * @param disabledItems
 * @param cols
 * @returns {*}
 */

var ConfigItem = function ConfigItem(_ref) {
  var _hideConfig$schema;
  var title = _ref.title,
    items = _ref.items,
    defaultSelected = _ref.defaultSelected,
    onChange = _ref.onChange,
    style = _ref.style,
    className = _ref.className,
    selectable = _ref.selectable,
    _ref$disabledItems = _ref.disabledItems,
    disabledItems = _ref$disabledItems === void 0 ? [] : _ref$disabledItems,
    _ref$cols = _ref.cols,
    cols = _ref$cols === void 0 ? 4 : _ref$cols,
    showTitle = _ref.showTitle,
    name = _ref.name;
  var handleSelect = function handleSelect(index, e) {
    if (Array.from(e.target.classList).some(function (v) {
      return v.match('ant');
    })) {
      return;
    }
    if (disabledItems[index]) {
      return;
    }
    onChange(index);
  };
  var _useContext = useContext(ThemeContext),
    schema = _useContext.schema;
  return !((_hideConfig$schema = hideConfig[schema]) === null || _hideConfig$schema === void 0 ? void 0 : _hideConfig$schema[name]) ? /*#__PURE__*/React.createElement(ConfigContainer, {
    style: style || {},
    className: className || ''
  }, title && /*#__PURE__*/React.createElement(Title, null, title), /*#__PURE__*/React.createElement(ContentWrapper, {
    className: "config-content"
  }, items.map(function (item, index) {
    return /*#__PURE__*/(
      // eslint-disable-next-line react/no-array-index-key
      React.createElement(_Col, {
        span: 24 / cols,
        className: "item-outer-wrapper",
        key: index
      }, /*#__PURE__*/React.createElement(ItemWrapper, {
        onClick: function onClick(e) {
          return handleSelect(index, e);
        },
        className: "config-item-wrapper ".concat(index === defaultSelected ? 'selected' : '', " ").concat(disabledItems[index] ? 'item-disabled' : '')
      }, showTitle && /*#__PURE__*/React.createElement(ItemTitle, {
        className: "config-item-title"
      }, NumberMap[index]), item.render && item.render, defaultSelected === index && selectable && /*#__PURE__*/React.createElement(CheckedIcon, {
        className: "check-icon"
      })), item.bottomTitle && /*#__PURE__*/React.createElement("p", {
        className: "bottom-title"
      }, item.bottomTitle))
    );
  }))) : null;
};
ConfigItem.defaultProps = {
  title: '',
  items: [],
  onChange: function onChange() {},
  defaultSelected: 0,
  selectable: true,
  name: ''
};
export default ConfigItem;